import React from 'react';
import { Button, Form } from "react-bootstrap";

const StepOne = ({ activeStep, setActiveStep }) => {
    return (
        <>
            <div className="row justify-content-center">
                <div className="col-xl-10">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h5 className="text-center">Consent and Legal Agreements</h5>

                            <div className="row">
                                <div className="row">
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentBackground'>Consent for Background Check:</Form.Label>
                                            <Form.Check
                                                type="checkbox"
                                                id="ConsentBackground"
                                                label="I give consent for background check"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentDrug'>Consent for Drug Testing:</Form.Label>
                                            <Form.Check
                                                type="checkbox"
                                                id="ConsentDrug"
                                                label="I give consent for drug testing"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentSocial'>Consent for Social Security Verification:</Form.Label>
                                            <Form.Check
                                                type="checkbox"
                                                id="ConsentSocial"
                                                label="I give consent for social security verification"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-lg-6">
                                        <Form.Group className="mb-3">
                                            <Form.Label htmlFor='ConsentVR'>Consent to MVR Check:</Form.Label>
                                            <Form.Check
                                                type="checkbox"
                                                id="ConsentVR"
                                                label="I give consent to MVR check"
                                            />
                                        </Form.Group>
                                    </div>

                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="secondary"
                                        className="mt-auto w-100"
                                        onClick={() => setActiveStep(5)}
                                    >
                                        Previous
                                    </Button>
                                </div>
                                <div className="col-lg-3 d-flex mb-3">
                                    <Button
                                        variant="primary"
                                        className="text-white mt-auto w-100"
                                        onClick={() => setActiveStep(7)}
                                    >
                                        Next
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StepOne;